import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CountryDivisionRS, CountryRS, DestinationRS } from '../../models/country.models';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private http: HttpClient) { }

  getAllCountries() {
    return this.http.get<CountryRS>(`${environment.URL_API}countries`).pipe(
      map((countryRs: CountryRS) => countryRs.countries)
    )
  }

  getCountryDivision(countryId: string) {
    let params: HttpParams = new HttpParams();
    params = params.append('countryId', countryId);

    return this.http.get<CountryDivisionRS>(`${environment.URL_API}countryDivisions`, { params: params}).pipe(
      map((countryDivisionRs: CountryDivisionRS) => countryDivisionRs.countryDivisions)
    )
  }

  getDestination(countryDivisionId: string) {
    let params: HttpParams = new HttpParams();
    params = params.append('countryDivisionId', countryDivisionId);

    return this.http.get<DestinationRS>(`${environment.URL_API}destinations`, { params: params}).pipe(
      map((destinationRs: DestinationRS) => destinationRs.destinations)
    )
  }
}
